import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useFilterStore = defineStore('filter', () => {
  const clientFilterCount = ref(0);
  const patientFilterCount = ref(0);
  const clinicianFilterCount = ref(0);
  const supportAgentFilterCount = ref(0);
  const inviteFilterCount = ref(0);
  const zbedgeUserFilterCount = ref(0);
  const clearClientFilterCount = ref(0);
  const clearPatientFilterCount = ref(0);
  const clearSupportAgentFilterCount = ref(0);
  const clearClinicianFilterCount = ref(0);
  const clearInviteFilterCount = ref(0);
  const clearZBEdgeUserFilterCount = ref(0);

  function setClearFilter() {
    clearPatientFilterCount.value++
    clearClientFilterCount.value++
    clearSupportAgentFilterCount.value++
    clearClinicianFilterCount.value++
    clearInviteFilterCount.value++
    clearZBEdgeUserFilterCount.value++
  }

  return {
    clientFilterCount,
    patientFilterCount,
    clinicianFilterCount,
    supportAgentFilterCount,
    inviteFilterCount,
    zbedgeUserFilterCount,
    clearClientFilterCount,
    clearPatientFilterCount,
    clearSupportAgentFilterCount,
    clearClinicianFilterCount,
    clearInviteFilterCount,
    clearZBEdgeUserFilterCount,
    setClearFilter,
  }
})
